import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/reportingCycles'
import { actionCreators as collisionActionCreators } from '@/store/ReportingCycleCollisions'
import { localized } from '@/decorators/localized'
import { Main, MainTop, MainTopTitle, MainTopLeft, MainBody } from '@/components/Layout'
import { BsrsGrid } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import context from '@/context'
import Resx from '@/components/Resx'
import { nameGridCell, dateCell, frequencyCell, commandCell } from './gridButtons'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import LoadingIndicator from '@/components/LoadingIndicator'
import { Button } from '@/components/button'
import { withPermissions } from '@/decorators/withPermissions'

@localized()
@withPermissions()
class ReportingCycles extends React.Component {
  openNewReportingCycleDialog () {
    const { localize } = this.props
    this.props.openDialog({
      dialogType: dialogTypes.newReportingCycle,
      year: { number: this.getYear() },
      localize,
      onAction: input => this.props.create(input)
    })
  }
  getYear () { return this.props.match.params.year }
  canManage () { return this.props.isGranted('CanManageReportingCalendars') }
  render () {
    const { localize, localizeProps, reportingCycleCollisions, reportingCycles, getCollisionDates, openDialog, deleteCycle } = this.props
    const year = this.getYear()
    const canManage = this.canManage()
    return (
      <React.Fragment>
        <Main>
          <MainTop>
            <MainTopTitle><Resx name='Reporting.ReportingCycles' /> {year}</MainTopTitle>
            <MainTopLeft>
              {reportingCycles.creating && <LoadingIndicator inline style={{ position: 'relative', top: '7px' }} />}
              {canManage && <Button
                className={'btn-sm'}
                title={localize('Reporting.AddNew')}
                color='primary'
                disabled={reportingCycles.creating}
                icon='plus'
                onClick={() => this.openNewReportingCycleDialog()}>{localize('Reporting.AddReportingCycle')}</Button>}
            </MainTopLeft>
          </MainTop>
          <MainBody>
            {reportingCycles.deleting && <div style={{ position: 'relative' }}><LoadingIndicator /></div>}
            <BsrsGrid
              dataSource={request => context.api.reportingCyclesService.getAllTableData(year, request)}
              filterable={false}
              onRowClick={this.rowClick}
              lastReloadedAt={reportingCycles.componentKey}
              onItemChange={this.itemChange}>
              <Column title={localize('Common.Name')} editable={false} cell={nameGridCell({ localize, localizeProps, reportingCycleCollisions, getCollisionDates, year })} />
              <Column title={localize('Reporting.Frequency')} width='150px' editable={false} cell={frequencyCell({ localize })} />
              <Column title={localize('Reporting.SnapshotDate')} width='300px' editable={false} cell={dateCell({ localize, isDueDate: false })} />
              <Column title={localize('Reporting.DueDate')} width='300px' editable={false} cell={dateCell({ localize, isDueDate: true })} />
              <Column field='extendedGraceDueDate' title={localize('Reporting.ExtendedGraceDueDate')} width='100px' editor='numeric' editable={false} />
              <Column cell={commandCell({ year, openDialog, localize, deleteCycle, disabled: !canManage })} width='50px' editable={false} />
            </BsrsGrid>
          </MainBody>
        </Main>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    reportingCycles: state.reportingCycles,
    reportingCycleCollisions: state.reportingCycleCollisions,
    ...ownProps
  }
}

const mapDispatchToProps = {
  create: actionCreators.create,
  deleteCycle: actionCreators.delete,
  getCollisionDates: collisionActionCreators.getCollisionDates,
  openDialog: dialogActions.openDialog
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportingCycles)



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportingCycles/list.js